// Main tab types
export type RevenueTab =
  | 'overview'
  | 'recognition'
  | 'reconciliation'
  | 'reporting'
  | 'policies';

// Section tab types for each main tab
export type RecognitionSection =
  | 'deals'
  | 'ssp-allocation'
  | 'calculations'
  | 'revenue-schedule'
  | 'deferred-revenue-schedule'
  | 'journal-entries';

export type ReconciliationSection = 'invoice-matching';

export type PoliciesSection = 'contract-items' | 'performance-obligations';

// Contract detail tab types
export type ContractDetailTab =
  | 'general-info'
  | 'contract-items'
  | 'revenue-checklist'
  | 'revenue-arrangements'
  | 'key-terms'
  | 'contract-mods';

export const DEFAULT_CONTRACT_DETAIL_TAB: ContractDetailTab = 'general-info';

// Default values
export const DEFAULT_TAB: RevenueTab = 'recognition';
export const DEFAULT_RECOGNITION_SECTION: RecognitionSection = 'deals';
export const DEFAULT_RECONCILIATION_SECTION: ReconciliationSection =
  'invoice-matching';
export const DEFAULT_POLICIES_SECTION: PoliciesSection = 'contract-items';

// URL constants
export const revenueURLs = {
  // Base path
  base: '/revenue',
  _base_relative_path: 'revenue',

  // Overview tab
  overview: '/revenue/overview',
  _overview_relative_path: 'overview',

  // Recognition tab
  recognition: '/revenue/recognition',
  _recognition_relative_path: 'recognition',

  // Recognition sections
  recognition_contract_analysis: '/revenue/recognition/deals',
  recognition_ssp_allocation: '/revenue/recognition/ssp-allocation',
  recognition_calculations: '/revenue/recognition/calculations',
  recognition_revenue_schedule: '/revenue/recognition/revenue-schedule',
  recognition_deferred_revenue:
    '/revenue/recognition/deferred-revenue-schedule',
  recognition_journal_entries: '/revenue/recognition/journal-entries',

  // Reconciliation tab
  reconciliation: '/revenue/reconciliation',
  _reconciliation_relative_path: 'reconciliation',

  // Reconciliation sections
  reconciliation_invoice_matching: '/revenue/reconciliation/invoice-matching',

  // Reporting tab
  reporting: '/revenue/reporting',
  _reporting_relative_path: 'reporting',

  // Policies tab
  policies: '/revenue/policies',
  _policies_relative_path: 'policies',

  // Policies sections
  policies_contract_items: '/revenue/policies/contract-items',
  policies_performance_obligations: '/revenue/policies/performance-obligations',

  // Detail pages
  contract_detail: (id: string, tab?: ContractDetailTab) =>
    `/revenue/contract/${id}${tab ? `/${tab}` : ''}`,
  contract_detail_tab: (id: string, tab: ContractDetailTab, itemId?: string) =>
    `/revenue/contract/${id}/${tab}${itemId ? `/${itemId}` : ''}`,
  invoice_detail: (id: string) => `/revenue/invoice/${id}`,
  recognition_schedule_detail: (id: string, type?: 'revenue' | 'deferred') =>
    `/revenue/recognition-schedule/${id}${type ? `/${type}` : ''}`,
  report_detail: (id: string) => `/revenue/reports/${id}`,

  // Helpers
  recognitionSection: (section: RecognitionSection) =>
    `/revenue/recognition/${section}`,
  reconciliationSection: (section: ReconciliationSection) =>
    `/revenue/reconciliation/${section}`,
  policiesSection: (section: PoliciesSection) => `/revenue/policies/${section}`,
} as const;
